"use strict";
import Common from "./Common";
import SplashScene from "./SplashScene";
import IntroScene from "./IntroScene";
import GameScene from "./GameScene";
import ResultsScene from "./ResultsScene";

export default class Application {
    constructor() {

    }

    static init() {

        const g = new PIXI.Graphics();
        g.beginFill(0x0);
        g.drawEllipse(0, 0, 75, 25);
        g.endFill();

        Common.shadowTexture = Common.renderer.generateTexture(g);//generate our shadow texture now

        g.destroy();

        if (Common.language === "en_US") Common.language = "en";// i find the en_US thing a pain in the ass so doing this for now.

        Common.copy = Common.assets.json("copy");
        Common.config = Common.assets.json("config");
        Common.isDebug = Common.config.debug;

        //--load paths here (config needs to be loaded first to get value for number of paths)--//
        const files = [];
        for (let i = 1; i <= Common.config.total_paths; i++) {
            files.push({name: "path_" + i, url: "data/paths/" + "path_" + i + ".json"});
        }
        Common.assets.addFiles(files, "assets/");
        Common.assets.load();

        delay(()=> {
            Application.showSplashScene();
            // Application.showGameScene();
            //Application.showResultsScene();
        }, 0.5, this);

    }

    /**
     * @returns {Scene}
     */
    static showSplashScene() {

        Common.paused = false;

        const scene = new SplashScene();

        scene.signals.next.add(function () {
            Application.showIntroScene();
        }, this);

        Common.scene.show(scene);

        return scene;

    }

    /**
     * @returns {Scene}
     */
    static showIntroScene() {

        Common.paused = false;

        const scene = new IntroScene();

        scene.signals.next.add(function () {
            Application.showGameScene();
        }, this);

        Common.scene.show(scene);

        return scene;

    }

    static showGameScene() {

        const scene = new GameScene();

        scene.signals.next.add(function (scene) {
            Application.showResultsScene();
        }, this);

        scene.signals.home.add(function (scene) {
            Application.showSplashScene();
        }, this);

        Common.scene.show(scene);

        return scene;
    }

    /**
     * @returns {Scene}
     */
    static showResultsScene() {

        Common.paused = false;

        const scene = new ResultsScene();

        scene.signals.next.add(function () {
            Application.showGameScene();
        }, this);

        scene.signals.home.add(function (scene) {
            Application.showSplashScene();
        }, this);

        // Common.scene.add(scene);
        Common.scene.show(scene);

        return scene;
    }
}